module.exports = {"data":{"site":{"siteMetadata":{"title":"aendrew.com v8","author":"Aendrew Rininsland"}},"markdownRemark":{"id":"/Users/andrew.rininsland/Projects/OTHER/aendrew.github.io/src/pages/projects/index.md absPath of file >>> MarkdownRemark","html":"","frontmatter":{"title":"Recent projects","date":"October 24, 2017"}}},"pathContext":{"path":"projects"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects.json
// module id = 670
// module chunks = 97786326051841